import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Modal } from '../../design/modals/modal/S_Modal';

interface ISaveBeforeAbandonDraftConfirmationModal {
  showSaveBeforeAbandonModal: boolean;
  onSaveBeforeAbandonConfirm: () => Promise<void>;
  onSaveBeforeAbandonCancel: () => void;
  onSaveBeforeAbandonDecline: () => Promise<void>;
}

export const SaveBeforeAbandonDraftConfirmationModal = observer((props: ISaveBeforeAbandonDraftConfirmationModal): ReactElement => {
  const { t } = useTranslator();

  return (
    <S_Modal
      isOpen={props.showSaveBeforeAbandonModal}
      toggle={props.onSaveBeforeAbandonCancel}
      headerText={t('save_changes')}
      buttons={
        <>
          <Button
            color='neutral'
            variant='outlined'
            onClick={props.onSaveBeforeAbandonCancel}
          >
            {t('cancel')}
          </Button>
          <Button
            variant='outlined'
            onClick={() => {
              void props.onSaveBeforeAbandonDecline();
            }}
          >
            {t('do_not_save')}
          </Button>
          <Button
            onClick={() => {
              void props.onSaveBeforeAbandonConfirm();
            }}
          >
            {t('save')}
          </Button>
        </>
      }
    >
      {t('draft_abandon_confirm_message')}
    </S_Modal>
  );
});
